/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ChangeContainerTargetBobbinQuantityEntry } from '../../models/change-container-target-bobbin-quantity-entry';

export interface ChangeContainerTargetBobbinQuantity$Params {
  productionOrderId: number;
      body: ChangeContainerTargetBobbinQuantityEntry
}

export function changeContainerTargetBobbinQuantity(http: HttpClient, rootUrl: string, params: ChangeContainerTargetBobbinQuantity$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, changeContainerTargetBobbinQuantity.PATH, 'post');
  if (params) {
    rb.path('productionOrderId', params.productionOrderId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

changeContainerTargetBobbinQuantity.PATH = '/api/v1/ProductionOrder/{productionOrderId}/container/targetBobbinQuantity';
